export const checkValidName = (Name) => {
  const regName = /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|]{1,6}$/;
  if (regName.test(Name)) {
    return true;
  }
  return false;
};
